import React from "react";
import { ConnectIcon } from "~/assets/svg/MathIcon";
import { useTranslation } from "react-i18next";
import DropdownTemplate, {
	DropDownItem,
} from "~/common/components/DropdownPortal/DropdownTemplate";
import darkNewImg from "~/common/components/Images";
import lightProfileImg from "~/assets/img/defaultImg/light-profile-large.png";
import { useGlobalStore } from "~/store";

const MemberList = ({
	teamMemberList,
	handleActive,
	handleDelete,
	setResendMailModal,
	setResendMember,
	handleClick
}) => {
	const { t } = useTranslation();

	const [
		{
			theme: { theme },
		},
	] = useGlobalStore();

	const TRANS_STATUS = {
		대기: t("pages.myPage.admin.TeamPage.standBy"),
		정상: t("pages.myPage.admin.TeamPage.normal"),
	};
	return (
		<div className="c__card" style={{ padding: 40 }}>
			<div className="invite-table">
				<ul className="thead">
					<li className="team-num">No</li>
					<li className="team-num">
						{/* 아이콘 */}
					</li>
					<li className="team-name">
						{t("pages.myPage.admin.TeamPage.invite-table.teamName")}
					</li>
					<li className="team-position">
						{/* 부서 */}
						부서
					</li>
					<li className="team-position">
						{/* 직급 */}
						직급
					</li>
					<li className="team-mail">
						{t("pages.myPage.admin.TeamPage.invite-table.teamEmail")}
					</li>

					<li className="team-role">
						{t("pages.myPage.admin.TeamPage.invite-table.teamRole")}
					</li>

					<li className="team-date">
						{t("pages.myPage.admin.TeamPage.invite-table.teamDate")}
					</li>
					<li className="team-active">
						<span className="team-status">{t("pages.myPage.admin.TeamPage.invite-table.teamActive")}</span>
					</li>
					<li className="dropdown-wrap" />
				</ul>

				{teamMemberList.map((member, index) => (
					<ul className="tr" key={index}
						onClick={() =>
							member.status === '정상' &&
							handleClick(member)}
					>
						<li className="td team-num">{index + 1}</li>
						<li className="td team-num">
							<div className="profile-img">
								<img
									src={member.img ? member.img : theme === "dark" ? darkNewImg : lightProfileImg}
									alt={t("pages.portfolio.PortfolioMemo.components.MemoItem.profile")}
								/>
							</div>
						</li>
						<li className="td team-name">{member.name}</li>
						<li className="td team-position">
							{member.department ?? '-'}
							{/* 부서 */}
						</li>
						<li className="td team-position">
							{member.position ?? '-'}
							{/* 직급 */}
						</li>
						<li className="td team-mail">{member.id}</li>
						<li className="td team-role">
							{member.role === "admin"
								? t("pages.myPage.userType.admin")
								: t("pages.myPage.userType.member")}
						</li>

						<li className="td team-date">{member.regDate}</li>
						<li className={`td team-active ${member.status === "정상" && "active"}`}>
							<span className="team-status">{TRANS_STATUS[member.status]}</span>
							{member.role !== "admin" && (
								<div
									onClick={(e) => e.stopPropagation()}
								>
									<DropdownTemplate target={member.idx} vertical>
										<DropDownItem
											onClick={() => {
												setResendMailModal(true);
												setResendMember(member);
											}}
										>
											{t("common.commonWord.button.mail")}
										</DropDownItem>
										<DropDownItem onClick={() => handleActive(member.idx)}>
											{TRANS_STATUS[member.status] === "정상"
												? t("common.commonWord.button.inactive")
												: t("common.commonWord.button.active")}
										</DropDownItem>
										<DropDownItem onClick={() => handleDelete(member.idx)}>
											{t("common.commonWord.button.delete")}
										</DropDownItem>
									</DropdownTemplate>
								</div>
							)}
						</li>
					</ul>
				))}
			</div>
		</div>
	);
};

export default MemberList;
